import { Button, CircularProgress, Dialog, DialogContent } from "@mui/material";
import DialogTitleWithCloseButton from "./DialogTitleWithCloseButton";
import React from "react";
import CenteredMessage from "./CenteredMessage";
import DownloadIcon from "@mui/icons-material/Download";


/**
 * 
 * @param {object} props 
 * @param {string} props.url
 * @param {string} props.name
 * @param {function} props.onClose
 * @returns 
 */
export default function FileViewer(props) {

   const [ loading, setLoading ] = React.useState(true);
   const [ error, setError ] = React.useState(false);
   const iframeRef = React.useRef();

   // encode url
   const [ lastComponent, ...rest ] = props.url.split('/').reverse();
   const url = [ ...rest.reverse(), encodeURIComponent(lastComponent) ].join('/');

   const reload = () => {
      setLoading(true);
      setError(false);
      iframeRef.current.src = url;
   }

   const title = props.name || "File Viewer";
   const filename = url.split('/').pop();

   const downloadButton = <a download={filename} href={url}>
      <Button
         color="primary"
         className="mx-4"
         startIcon={<DownloadIcon />}
         size="small"
      >
         Download
      </Button>
   </a>

   return <Dialog open fullScreen>
      <DialogTitleWithCloseButton 
         onClose={props.onClose}
         actions={downloadButton}
      >
         {title}
      </DialogTitleWithCloseButton>
      <DialogContent dividers>
         <iframe
            ref={iframeRef}
            src={url}
            width="100%"
            height={loading || error ? '0%' : '100%'}
            title={title}
            onLoad={() => setLoading(false)}
            onError={e => {
               setLoading(false);
               setError(true);
               console.error(e);
            }}
         />
         {
            loading && <div className="h-full flex items-center justify-center">
               <CircularProgress />
            </div>
         }
         {
            error && <div className="h-full">
               <CenteredMessage message={"Failed to load file"} onRefresh={reload} />
            </div>
         }
      </DialogContent>
   </Dialog>
}